// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "frontend-assets/js/" + chunkId + "." + {"22":"228412cb","60":"0e28f076","91":"493a5453","319":"f2fca845","335":"d098b98d","336":"71c1e52a","394":"d9139028","559":"3cd5645d","576":"349fbfce","611":"31fa2aa2","692":"1b54be7f","725":"05e5f9ea","760":"628060bf","871":"435f29f7","922":"4c378d6e"}[chunkId] + ".js";
};